import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  paper: {
    // border/radius moved to the `.table-wrap`-equivalent wrapper div around
    // this table (see index.tsx) — the mockup's `.table-wrap` pattern, applied
    // once here so every TableView call site (Benefits, Audit Logs, Subscription
    // history, SR search results, ...) gets it automatically.
    marginTop: 0,
    marginBottom: 0,
  },
};

export default styles;
